<template>
	<AppLayout :title="trans('admin.audit.elections.thanks')">
		<div class="grow flex flex-col items-center justify-center gap-8 overflow-y-auto">
			<i class="fa-solid fa-check-circle text-green-800 text-[200px]"/>
			<p class="text-5xl font-thin text-gray-400">{{ trans('admin.audit.elections.thanks') }}</p>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import AppLayout from '@/Layouts/AppLayout.vue'
</script>